import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Container, Paper, Typography, Stack, Avatar } from '@mui/material';
import { Redeem as RedeemIcon } from '@mui/icons-material';
import LuckyDrawPrizes from './LuckyDrawPrizes';

const LuckyDrawPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <style>
        {`
          @keyframes float {
            0%, 100% { transform: translateY(0px) rotate(0deg); }
            25% { transform: translateY(-10px) rotate(1deg); }
            50% { transform: translateY(-20px) rotate(0deg); }
            75% { transform: translateY(-10px) rotate(-1deg); }
          }
        `}
      </style>
      <Container maxWidth="xl" sx={{ py: { xs: 2, md: 4 }, px: { xs: 2, md: 3 } }}>
        <Paper
          elevation={8}
          sx={{
            borderRadius: 4,
            overflow: 'hidden',
            background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
            boxShadow: '0 25px 50px rgba(0,0,0,0.15)',
            border: '1px solid rgba(255,255,255,0.2)'
          }}
        >
          <Paper
            elevation={0}
            sx={{
              background: 'linear-gradient(135deg, #2c3e50 0%, #3498db 100%)',
              color: 'white',
              borderRadius: 0,
              p: { xs: 3, md: 5 },
              position: 'relative',
              overflow: 'hidden',
              boxShadow: 'none'
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                opacity: 0.08,
                backgroundImage: `
                  radial-gradient(circle at 20% 20%, white 1px, transparent 1px),
                  radial-gradient(circle at 80% 80%, white 1px, transparent 1px),
                  radial-gradient(circle at 40% 40%, white 1px, transparent 1px)
                `,
                backgroundSize: '60px 60px, 80px 80px, 40px 40px',
                animation: 'float 20s ease-in-out infinite'
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                top: '10%',
                right: '15%',
                width: 100,
                height: 100,
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.1)',
                backdropFilter: 'blur(10px)',
                animation: 'float 15s ease-in-out infinite reverse'
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                bottom: '20%',
                left: '10%',
                width: 60,
                height: 60,
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.08)',
                backdropFilter: 'blur(8px)',
                animation: 'float 12s ease-in-out infinite'
              }}
            />

            <Stack direction="row" alignItems="center" spacing={3} sx={{ position: 'relative', zIndex: 1 }}>
              <Avatar
                sx={{
                  bgcolor: 'rgba(255,255,255,0.25)',
                  width: { xs: 56, md: 72 },
                  height: { xs: 56, md: 72 },
                  border: '3px solid rgba(255,255,255,0.4)',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
                  backdropFilter: 'blur(10px)'
                }}
              >
                <RedeemIcon sx={{ fontSize: { xs: 28, md: 36 }, color: 'white' }} />
              </Avatar>
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontWeight: 900,
                    mb: 0.5,
                    fontSize: { xs: '2rem', sm: '2.5rem', md: '3.5rem' },
                    textShadow: '0 4px 20px rgba(0,0,0,0.3)',
                    background: 'linear-gradient(45deg, #ffffff 0%, #f0f8ff 100%)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    letterSpacing: '-0.02em'
                  }}
                >
                  {t('app.title.luckyDraw', { defaultValue: 'Lucky Draw' })}
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    opacity: 0.95,
                    fontWeight: 500,
                    fontSize: { xs: '0.9rem', sm: '1rem', md: '1.3rem' },
                    textShadow: '0 2px 10px rgba(0,0,0,0.2)',
                    letterSpacing: '0.01em'
                  }}
                >
                  {t('luckyDraw.subtitle', { defaultValue: 'Manage lucky draw prizes for the current brand.' })}
                </Typography>
              </Box>
            </Stack>
          </Paper>

          <Box
            sx={{
              p: { xs: 3, md: 4 },
              position: 'relative',
              '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '1px',
                background: 'linear-gradient(90deg, transparent 0%, rgba(52, 152, 219, 0.3) 50%, transparent 100%)'
              }
            }}
          >
            <LuckyDrawPrizes />
          </Box>
        </Paper>
      </Container>
    </>
  );
};

export default LuckyDrawPage;
